import React from "react";

import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import "../styles/Map.css";

function Maps() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyC55zHt7sJv7T4uRl8gBy3TmHmOACmcH9Y",
  });

  if (!isLoaded) return <div>Loading...</div>;

  const center = {
    lat: -12.076813,
    lng: -77.107496,
  };
  const position = {
    lat: -12.076813,
    lng: -77.107496,
  };

  return (
    <GoogleMap zoom={20} center={center} mapContainerClassName="map-container">
      <Marker position={position} />
    </GoogleMap>
  );
}

export default Maps;
